import { Skeleton } from './Skeleton';

/**
 * Mirrors {@code ProductDetailPage}'s grid: image + thumbnails on the left,
 * label/title/rating/price/description/CTA on the right.
 */
export function ProductDetailSkeleton() {
  return (
    <section className="max-w-editorial mx-auto px-6 sm:px-10 py-10" aria-hidden="true">
      <Skeleton className="h-4 w-32 mb-8" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
        <div className="flex flex-col gap-4">
          <div className="relative aspect-[4/5] overflow-hidden bg-linen">
            <Skeleton className="absolute inset-0 rounded-none" label="Loading product image" />
          </div>
          <div className="grid grid-cols-4 gap-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="relative aspect-square overflow-hidden bg-linen">
                <Skeleton className="absolute inset-0 rounded-none" />
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          <Skeleton className="h-3 w-40 mb-3" />
          <Skeleton className="h-12 w-full mb-3" />
          <Skeleton className="h-12 w-3/4 mb-6" />

          <div className="flex items-center gap-2 mb-6">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-12" />
          </div>

          <div className="flex items-baseline gap-4 mb-8 pb-8 border-b border-linen">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-10 w-32" />
          </div>

          <div className="mb-10">
            <Skeleton className="h-3 w-28 mb-3" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-2/3" />
          </div>

          <Skeleton className="h-14 w-full mt-auto" />
        </div>
      </div>
    </section>
  );
}
